// extracted by mini-css-extract-plugin
export default {"pageLayout":"k-z","mainContent":"l-z","columnLayout":"m-z","columnLayoutFill":"n-z","columnLayoutLast":"o-z"};